<app-loader *ngIf="isDisabled"></app-loader>

<div class="container-fluid">
  <div class="card border-radius-0 mt-1 p-0">

    <div class="card-header">
        Investment Declaration Details
    </div>

    <div class="card-body p-3">
      <form #FilterForm="ngForm">

        <!-- Monthly Report -->
        <ng-container>
          <!-- Line 1: Employee Type & Tax Based -->
          <div class="row">
            <div class="col-md-6 mb-3">
              <label class="form-label d-block mb-1">
                Employee Type
              </label>
              <div class="btn-group btn-group-toggle">
                <label class="form-check-label me-3">
                  <input type="radio" class="form-check-input" value="" name="EmpType" [(ngModel)]="Detail.EmpType">
                  All
                </label>
                <label class="form-check-label px-1">
                  <input type="radio" class="form-check-input" value="FRONT" name="EmpType"
                    [(ngModel)]="Detail.EmpType">
                  Front Office
                </label>
                <label class="form-check-label px-1 ms-2">
                  <input type="radio" class="form-check-input" value="BACK" name="EmpType" [(ngModel)]="Detail.EmpType">
                  Back Office
                </label>
              </div>
            </div>

            <div class="col-md-6 mb-3">
              <label class="form-label d-block mb-1">
                Tax Based
              </label>
              <div class="d-flex">
                <label class="form-check-label me-3">
                  <input type="radio" class="form-check-input" value="" name="TaxBasedon"
                    [(ngModel)]="Detail.TaxBasedon">
                  All
                </label>
                <label class="form-check-label me-3">
                  <input type="radio" class="form-check-input" value="Declaration" name="TaxBasedon"
                    [(ngModel)]="Detail.TaxBasedon">
                  Declaration
                </label>
                <label class="form-check-label">
                  <input type="radio" class="form-check-input" value="Investment" name="TaxBasedon"
                    [(ngModel)]="Detail.TaxBasedon">
                  Investment
                </label>
              </div>
            </div>
          </div>

          <!-- Line 2: Financial Year, Branch, & Tax Month -->
          <div class="row">
            <div class="col-md-4 mb-3">
              <label class="form-label">
                Financial Year
              </label>
              <ng-select name="FinancialYear" [items]="FinancialYears" bindLabel="FinancialYear"
                bindValue="FinancialYearValue" [(ngModel)]="Detail.FinancialYear" placeholder="Select Financial Year">
              </ng-select>
            </div>

            <div class="col-md-6 mb-3">
              <label class="form-label">
                Branch
              </label>
              <ng-select name="BranchID" [items]="Branchs" bindLabel="BranchName" bindValue="BranchMasterID"
                [(ngModel)]="Detail.BranchID" placeholder="Select Branch" [clearable]="true">
              </ng-select>
            </div>

            <!-- <div class="col-md-4 mb-3">
              <label class="form-label">
                Tax Month
              </label>
              <input type="month" class="form-control" name="TaxMonth" [(ngModel)]="Detail.TaxMonth">
            </div> -->
          </div>

          <!-- Line 3: Employee Code -->
          <div class="row">
            <div class="col-md-4 mb-3">
              <label class="form-label">
                Employee Code
              </label>
              <input type="text" class="form-control" name="Empcode" [(ngModel)]="Detail.Empcode"
                placeholder="Employee Code">
            </div>
          </div>
        </ng-container>
      </form>
    </div>

    <!-- Footer -->
    <div class="card-footer">
      <div class="text-end">
        <button type="button" class="btn btn-primary" [disabled]="isDisabled" (click)="excelDownload()">
          <i *ngIf="!isDisabled" class="bi bi-download me-1">
          </i>
          <span *ngIf="isDisabled" class="spinner-border spinner-border-sm me-1">
          </span>
          {{ !isDisabled ? 'Excel' : 'Loading...' }}
        </button>
      </div>
    </div>

  </div>
</div>